<template>
  <div>
    <h1>Vat test</h1>
    <v-btn :to="{ name: 'vatActions' }">
      <v-icon>chevron_left</v-icon>Vat actions
    </v-btn>
    <v-select
      label="Vat registration number"
      v-model="vrn"
      :items="vrns"
      item-value="vrn"
      item-text="name"
    />
    <a @click="createVatTest">Start submission process</a>
  </div>
</template>

<script>
import CREATE_VAT_TEST from "@/graphql/accounts/vat/CreateVatTest";
import CREATE_VATTOKEN from "@/graphql/accounts/vat/CreateVatToken";
import VATTOKEN from "@/graphql/accounts/vat/VatToken";
import { getClientHeaders } from "../../util/helpers";
export default {
  name: "VatTest",
  metaInfo() {
    return {
      title: "Vat test",
      titleTemplate: "%s - Accounts - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  data() {
    return {
      vrns: [
        { name: "Company ZYPZDK", vrn: 140793274 },
        { name: "Company TWAICX", vrn: 112307524 }
      ],
      vrn: null,
      redirectUri: `${process.env.VUE_APP_MY_URL}/vatTest`
    };
  },
  methods: {
    async fetchVatToken() {
      const response = await this.$apollo.query({
        query: VATTOKEN,
        variables: {
          test: true
        }
      });
      return response.data.vatToken;
    },
    async createVatTest() {
      const clientHeaders = getClientHeaders();
      await this.$apollo.mutate({
        mutation: CREATE_VAT_TEST,
        variables: {
          test: true,
          vrn: this.vrn,
          clientHeaders
        }
      });
      this.$router.push({
        name: "vatActions"
      });
    },
    requestOauthCode() {
      const urlSearchParams = new URLSearchParams({
        response_type: "code",
        client_id: process.env.VUE_APP_HMRC_OAUTH_TEST_CLIENTID,
        scope: "read:vat+write:vat",
        // state: vatid,
        redirect_uri: this.redirectUri
      });
      const url = `${process.env.VUE_APP_HMRC_OAUTH_TEST_BASEURL}/oauth/authorize?${urlSearchParams}`;
      //   console.log(url);
      window.location.href = url;
    },
    async createVatToken() {
      const response = await this.$apollo.mutate({
        mutation: CREATE_VATTOKEN,
        variables: {
          test: true,
          redirectUri: this.redirectUri,
          code: this.$route.query.code
        }
      });
      return response.data.createVatToken;
    }
  },
  watch: {
    "$route.query.code": {
      immediate: true,
      handler() {
        if (this.$route.query.code) {
          this.createVatToken();
        }
      }
    }
  },
  created: async function () {
    if (this.$route.query.code) {
      return;
    }
    const isVatToken = await this.fetchVatToken();
    if (!isVatToken) {
      this.requestOauthCode();
    }
  }
};
</script>
